import { render, staticRenderFns } from "./EmbeddedPlaylists.vue?vue&type=template&id=918f5f40&scoped=true&"
import script from "./EmbeddedPlaylists.vue?vue&type=script&lang=js&"
export * from "./EmbeddedPlaylists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918f5f40",
  null
  
)

export default component.exports